import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const EventCartContext = createContext(null);
const KEY = "av_event_cart";

export function EventCartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '{"artists":[],"shows":[]}');
    } catch (err) {
      console.warn("[cart] failed to parse stored cart", err?.message || err);
      return { artists: [], shows: [] };
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (err) {
      console.warn("[cart] failed to persist cart", err?.message || err);
    }
  }, [items]);

  const addArtist = useCallback(
    (a) =>
      setItems((p) =>
        p.artists.find((x) => x.id === a.id) ? p : { ...p, artists: [...p.artists, a] }
      ),
    []
  );
  const removeArtist = useCallback(
    (id) => setItems((p) => ({ ...p, artists: p.artists.filter((a) => a.id !== id) })),
    []
  );
  const addShow = useCallback(
    (s) =>
      setItems((p) =>
        p.shows.find((x) => x.id === s.id) ? p : { ...p, shows: [...p.shows, s] }
      ),
    []
  );
  const removeShow = useCallback(
    (id) => setItems((p) => ({ ...p, shows: p.shows.filter((s) => s.id !== id) })),
    []
  );
  const clear = useCallback(() => setItems({ artists: [], shows: [] }), []);

  const count = items.artists.length + items.shows.length;

  const value = useMemo(
    () => ({ items, addArtist, removeArtist, addShow, removeShow, clear, count }),
    [items, addArtist, removeArtist, addShow, removeShow, clear, count]
  );

  return <EventCartContext.Provider value={value}>{children}</EventCartContext.Provider>;
}

export function useEventCart() {
  return useContext(EventCartContext);
}
